// extracted by mini-css-extract-plugin
export default {"input":"styles_input__EjdDL","button":"styles_button__1jNa4"};